import { render, staticRenderFns } from "./revenue-dashboard-icon.vue?vue&type=template&id=23e11c5e"
import script from "./revenue-dashboard-icon.vue?vue&type=script&lang=js"
export * from "./revenue-dashboard-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports